export function leadsLink(value) {
  return process.env.REACT_APP_ENV === 'development'
    ? `http://localhost:3105/${value}`
    : `${document.location.origin.replace('admin', 'leads')}/${value}`
}

export function embedCode(value) {
  return `<iframe src="${leadsLink(
    value
  )}" style="height: 650px; width:100%; border: 0;display: block;margin: auto;" allow="geolocation"></iframe>`
}

export function trackingCode(value) {
  return `<script type="text/javascript" id="" charset="">function greyfinchEmbedListener(c){function e(d){typeof c==="string"&&a===null&&(a=document.getElementById(c));try{if(window.dataLayer&&/(localhost|\.greyfinch\.com)/.test(d.origin)&&(a===null||a.contentWindow===d.source)){var b=JSON.parse(d.data);console.log({type:"greyfinch/leads",iframeId:c,data:b});b.event&&b.event.event==="pageview"&&window.dataLayer.push(b.event)}}catch(f){}}var a=null;typeof window.addEventListener==="function"?window.addEventListener("message",e):typeof window.attachEvent===
"function"?window.attachEvent("onmessage",e):console.error("Failed to initialize Greyfinch embedded app event parser")}greyfinchEmbedListener();</script>`
}
